import { Col, Row } from '@surecompanies/core_components'
import useAssigneeList from 'hooks/useAssigneeList'
import React, { memo } from 'react'
import ApplicationGridCard from './ApplicationGridCard'

export interface BenefitQueue {
  assignee: string
  count: number
}

export interface ApplicationGridContainerProps {
  benefitQueues: BenefitQueue[]
}

export const ApplicationGridContainer = ({
  benefitQueues,
}: ApplicationGridContainerProps) => {
  const assigneeList = useAssigneeList({ isIncludeSpecialAssignee: true })

  return (
    <Row gutter={[16, 24]}>
      {assigneeList.map((assignee) => {
        return (
          <Col key={assignee}>
            <QueueItem
              assignee={assignee}
              value={benefitQueues.find((q) => q.assignee === assignee)}
            />
          </Col>
        )
      })}
    </Row>
  )
}

const QueueItem = memo(
  ({
    assignee,
    value,
  }: {
    assignee: string
    value: BenefitQueue | undefined
  }) => {
    return (
      <Col key={assignee}>
        <ApplicationGridCard
          assignee={assignee}
          count={value?.count ?? 0}
          isLoading={!value}
        />
      </Col>
    )
  }
)
